import { render, staticRenderFns } from "./AddSops.vue?vue&type=template&id=10d83d2e&scoped=true&"
import script from "./AddSops.vue?vue&type=script&lang=js&"
export * from "./AddSops.vue?vue&type=script&lang=js&"
import style0 from "./AddSops.vue?vue&type=style&index=0&id=10d83d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d83d2e",
  null
  
)

export default component.exports